__turbopack_context__.v({
  "SelectContainer": "defaultStyles-module-scss-module__knrPKa__SelectContainer",
  "Select__Arrow": "defaultStyles-module-scss-module__knrPKa__Select__Arrow",
});
